module.exports = __webpack_public_path__ + "static/media/Einfach-Bequem1-small.e118c191.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Einfach-Bequem1-small.jpg
// module id = 233
// module chunks = 8